import { aegis } from '@/mod/aegis';
import { isSiteRequestError } from '@/request/error';

export function normalizeThrown(error: unknown): Error {
  if (error instanceof Error) {
    // SDK 会展开 Error 的可枚举属性，不能把请求配置等附加字段原样交给它。
    const safeError = new Error(error.message);
    safeError.name = error.name;
    safeError.stack = error.stack;
    return safeError;
  }
  if (typeof error === 'string') return new Error(error);
  if (typeof error === 'number' || typeof error === 'boolean' || typeof error === 'bigint') {
    return new Error(String(error));
  }
  return new Error('Non-Error value thrown');
}

export function reportException(error: unknown): void {
  if (isSiteRequestError(error)) return;
  aegis.error(normalizeThrown(error));
}
